import { BuildingStory } from '@/models/BuildingStory.ts'

export class BuildingHull {

  stories: BuildingStory[] = []

  constructor(stories?: BuildingStory[]) {
    this.stories = stories?.map(s => new BuildingStory(s)) || []
  }
}
